import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AvailabilityTaskSchedule } from '../cc-api/models';
import { getWeekDaysNameString } from 'src/app/utils/calendar-utils';
import { convertToSentenceCase } from '../utils/string-util';
import {
  LAUNCH,
  DESTROY,
  SCALE_UP,
  SCALE_DOWN,
} from '../constants/releaseTypes';

@Injectable({
  providedIn: 'root',
})
export class ScheduleStringService {
  constructor(private router: Router) {}
  scheduleString: string = '';
  availSchedule: AvailabilityTaskSchedule[];
  releaseOptions = {
    MON: 'Monday',
    TUE: 'Tuesday',
    WED: 'Wednesday',
    THU: 'Thursday',
    FRI: 'Friday',
    SAT: 'Saturday',
    SUN: 'Sunday',
  };

  convertTime(timeString) {
    var ts = timeString;
    var hours = +ts.substr(0, 2); //separate hours time from time string
    var h = hours % 12 || 12; //convert 24 hours to 12 hours clock
    var leadingZero = h < 10 ? '0' + h : h; //add leading zero in case of time being less than 10
    var type = hours < 12 ? ' AM' : ' PM'; // add AM or PM
    ts = leadingZero + ts.substr(2, 3) + type; //final time string construction
    return ts;
  }

  constructSchedule(schedule) {
    this.availSchedule = schedule;
    let isDaily = false;
    let launchTime = '';
    let destroyTime = '';
    if (
      schedule[0]?.byDay?.length === 1 &&
      schedule[0]?.byDay[0] === schedule[1]?.byDay[0]
    ) {
      schedule.forEach((schedule) => {
        if (this.isAvailabilityStart(schedule.releaseType)) {
          launchTime = schedule.byTime;
        }
        if (this.isAvailabilityStop(schedule.releaseType)) {
          destroyTime = schedule.byTime;
        }
      });
      if (launchTime > destroyTime) {
        isDaily = false;
      } else {
        isDaily = true;
      }
    }
    if (this.availSchedule[0]?.byDay?.length > 1 || isDaily) {
      this.scheduleString = 'Available daily on ';
      if (this.availSchedule[0]?.byDay.length > 1) {
        const readableWeekDayNames = this.availSchedule[0]?.byDay?.map(
          (day) => this.releaseOptions[day],
        );
        const orderedWeekdays = Object.values(this.releaseOptions);
        readableWeekDayNames.sort(
          (a, b) => orderedWeekdays.indexOf(a) - orderedWeekdays.indexOf(b),
        );
        this.scheduleString += `${getWeekDaysNameString(
          readableWeekDayNames,
        )} `;
      } else if (
        this.availSchedule[0]?.byDay === this.availSchedule[0]?.byDay
      ) {
        this.scheduleString +=
          this.releaseOptions[this.availSchedule[0]?.byDay[0]] + ' ';
      }
      this.scheduleString += 'from ';
      this.addDailyTimeFields();
      this.addScheduleRule();

      return this.scheduleString;
    } else {
      this.scheduleString = 'Available weekly from ';
      this.addWeeklyTimeFields();
      this.addScheduleRule();

      return this.scheduleString;
    }
  }

  addDailyTimeFields() {
    const availabilityStateType = this.availSchedule?.find((schedule) =>
      this.isAvailabilityStart(schedule.releaseType),
    );
    const availableStopType = this.availSchedule?.find((schedule) =>
      this.isAvailabilityStop(schedule.releaseType),
    );
    const availableStartTime = this.convertTime(availabilityStateType?.byTime);
    const availableStopTime = this.convertTime(availableStopType?.byTime);

    if (availableStartTime && availableStopTime) {
      this.scheduleString += `${availableStartTime} to ${availableStopTime}`;
    }
  }

  addWeeklyTimeFields() {
    const launchType = this.availSchedule?.find((schedule) =>
      this.isAvailabilityStart(schedule.releaseType),
    );
    const destroyType = this.availSchedule?.find((schedule) =>
      this.isAvailabilityStop(schedule.releaseType),
    );
    const availableStartDay = this.releaseOptions[launchType?.byDay[0]];
    const availableStartTime = this.convertTime(launchType?.byTime);
    const availableStopDay = this.releaseOptions[destroyType?.byDay[0]];
    const availableStopTime = this.convertTime(destroyType?.byTime);

    this.scheduleString += `${availableStartDay}, ${availableStartTime} to `;
    this.scheduleString += `${availableStopDay}, ${availableStopTime}`;
  }
  isAvailabilityStart = (releaseType) =>
    [LAUNCH, SCALE_UP].includes(releaseType);
  isAvailabilityStop = (releaseType) =>
    [DESTROY, SCALE_DOWN].includes(releaseType);

  addScheduleRule = () => {
    const releaseTypes = this.getScheduleRuleNames();
    this.scheduleString += ` using ${releaseTypes.join(' and ')}`;
  };
  getScheduleRuleNames = () =>
    this.availSchedule?.map(({ releaseType }) =>
      convertToSentenceCase(releaseType),
    );
  getTimezoneText = (availabilitySchedule) => {
    if (!availabilitySchedule?.length) {
      return '';
    }
    const { releaseType: startReleaseType, timeZone: startTimezone } =
      availabilitySchedule?.[0];
    const { releaseType: stopReleaseType, timeZone: stopTimezone } =
      availabilitySchedule?.[1];

    const stopSchedule = availabilitySchedule?.[1];
    if (startTimezone === stopTimezone) {
      return `All times are in ${startTimezone}`;
    }

    return `${convertToSentenceCase(
      startReleaseType,
    )} time is in ${startTimezone} and ${convertToSentenceCase(
      stopReleaseType,
    )} time is in ${stopTimezone}`;
  };
}
